"use client";

import { FeatureHighlight } from "@/components/shared/public";
import { useTranslations } from "next-intl";
import { architectsTemp } from "../../../../public/images/logos";

const ArchitectsCheck = () => {
  const t = useTranslations("sized.architectsCheck");
  return (
    <div className="gs--page-column py-16" id="architektenstempel">
      <FeatureHighlight
        src={architectsTemp}
        alt={"Bemaßte Grundrisse mit Architektenstempel Detail"}
        title={t("title")}
        text={t("text")}
        subText={t("subText")}
      />
    </div>
  );
};

export default ArchitectsCheck;
